import { Text, View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '15 30'
  },
  logoCont: {
    margin: 30,
    marginBottom: 0
  },
  logo: {
    textAlign: 'right'
  },
  text: {
    fontSize: '10'
  }
})

const Header = ({ data }) => {
  return (
    <>
      <View style={styles.logoCont}>
        <Text style={styles.logo}>Rehability</Text>
      </View>
      <View style={styles.header}>
        <Text style={styles.text}>
          Device Consumption {data.month ? `for ${data.month}` :
          data.start ? `- from ${data.start} until ${data.end}` : null}
        </Text>
      </View>
    </>
  )
}

export default Header
